// extracted by mini-css-extract-plugin
export default {"root":"Dz8p27Hi","header":"_26Z1B3lA"};